<script>
import ContactEntry from './contact-entry.vue'
import ContactNavbar from './contact-navbar.vue'
import PaginationButtons from '../pagination-buttons.vue'

export default {
  components: {ContactEntry, ContactNavbar, PaginationButtons},

  props: {
    userIds: {type: Array, default: null},
    talkContentCode: {type: String, default: null},
  },

  data() {
    return {
      filter: {},
      contacts: [],
      numContacts: 0,
      perPage: 60,
      numPages: 0,
      page: Number(this.$route.query.page) || 1,
      userUuid: this.$storage.getUserUuid(),
      directChannels: [],
    }
  },

  watch: {
    filter: {
      handler(newValue) {
        if (this.page !== 1) {
          // the page watcher takes care of fetch + query update
          this.page = 1
          return
        }
        this.fetchContacts(newValue)
        this.pushQuery(this.buildQuery())
      },
      deep: true
    },
    page: {
      handler(newValue) {
        this.fetchContacts(this.filter, newValue)
        this.pushQuery(this.buildQuery())
        window.scrollTo(0, 0)
      },
    },
  },

  created() {
    if (this.$route.query.search) {
      this.filter.search = this.$route.query.search
    }
    if (this.$route.query.categories) {
      const c = this.$route.query.categories
      this.$set(this.filter, 'categories', Array.isArray(c) ? c : [c])
    }
    if (this.$route.query.for_me) {
      this.$set(this.filter, 'for_me', 1)
    }
    if (this.userIds) {
      this.filter.uuid = this.userIds
    }
    if (this.talkContentCode) {
      this.filter.talk_code = this.talkContentCode
    }
    this.fetchContacts(this.filter, this.page)
  },

  methods: {
    pushQuery(query) {
      try {
        this.$router.push({query: query})
      } catch(error) {
        console.error(error)
      }
    },

    buildQuery() {
      let query = this.filter.search ? {search: this.filter.search} : {}
      if (this.filter.categories && this.filter.categories.length)
        query.categories = this.filter.categories
      if (this.filter.for_me)
        query.for_me = "1"
      if (this.page > 1)
        query.page = String(this.page)
      return query
    },

    contactUrl(contact) {
      return `/community/${contact.uuid}`
    },

    onSearchChanged: function (search) {
        this.$set(this.filter, 'search', search)
    },

    onCategories: function (ids) {
      this.$delete(this.filter, 'for_me')
      if (ids && ids.length)
        this.$set(this.filter, 'categories', ids)
      else
        this.$delete(this.filter, 'categories')
    },

    toggleForMe: function () {
      if (this.filter.for_me) {
        this.$delete(this.filter, 'for_me')
      } else {
        this.$delete(this.filter, 'categories')
        this.$set(this.filter, 'for_me', 1)
      }
    },

    fetchContacts: function (filter, page=1) {
      let me =  this
      let params = {page: page, limit: this.perPage, ...this.filter}
      me.$api.get('/community-users/', {params:params}).then(function(response){
        if (me.userUuid)
          me.contacts = response.data.results.filter(contact => contact.uuid !== me.userUuid) || []
        else
          me.contacts = response.data.results
        me.numContacts = response.data.count
        me.numPages = response.data.pages
      })
    },
  },
}
</script>

<template>

  <div>
    <contact-navbar v-if="!userIds" class="mb-1"
      :search="filter.search || ''"
      :categories="filter.categories || []"
      :for-me-active="!!filter.for_me"
      @search="onSearchChanged($event)"
      @delete-search="$delete(filter, 'search')"
      @categories="onCategories($event)"
      @toggle-for-me="toggleForMe()"
    />

    <ol v-if="!userIds && (filter.for_me || (filter.categories && filter.categories.length))"
        class="breadcrumb bg-white ps-0 mt-1">
      <li v-if="filter.for_me" class="breadcrumb-item active">
        <a class="badge badge-pill bg-primary me-1" style="text-decoration:none" @click.prevent="toggleForMe()">
          <b>Für mich&nbsp;</b><i class="far fa-times-circle"></i>
        </a>
      </li>
      <li v-if="filter.categories && filter.categories.length" class="breadcrumb-item active">
        <a class="badge badge-pill bg-primary me-1" style="text-decoration:none" @click.prevent="onCategories([])">
          <b>Kategorien ({{ filter.categories.length }})&nbsp;</b><i class="far fa-times-circle"></i>
        </a>
      </li>
    </ol>

    <div v-if="numContacts > 0">
      <small class="text-muted me-1">{{numContacts}} Treffer</small>

      <div class="list-group text-deco-none">
        <router-link v-for="contact in contacts" :key="contact.uuid" :to="contactUrl(contact)" class="text-deco-none">
          <contact-entry :contact="contact" />
        </router-link>
      </div>

      <pagination-buttons :page.sync="page" :num-pages="numPages" />

    </div>
    <div v-else>
      <div class="text-center mt-5">-- keine Treffer --</div>
    </div>

  </div>
</template>

<style scoped>
.text-deco-none {
  text-decoration: none;
}
</style>